import React from "react";
import LogoutIcon from "@icons/myicons/sidebar/logout.svg?react";
import { Box, IconButton, styled, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { SettingsMenu } from "@features/settings/components/SettingsSidebar/SettingsMenu";
import { BankConnections } from "@features/settings/components/SettingsSidebar/BankConnections";
import { SettingsMenuItem } from "@features/settings/components/SettingsSidebar/SettingsMenuItem.tsx";

const SidebarContainer = styled(Box)(({ theme }) => ({
  height: "100%",
  width: "280px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  flexShrink: 0,
  background: theme.palette.background.subtle,
  padding: theme.spacing(4, 4, 5),

  [theme.breakpoints.down("md")]: {
    paddingTop: theme.spacing(2),
  },
}));

export const SettingsSidebar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleBackClick = () => {
    if ((location.state as { from: string })?.from) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <SidebarContainer>
      <Box>
        <Box display="flex" alignItems="center" gap={2} mb={4}>
          <IconButton
            onClick={handleBackClick}
            sx={{
              "& svg": {
                width: "20px",
                height: "20px",
              },
            }}
          >
            <KeyboardArrowLeftIcon />
          </IconButton>
          <Typography variant="subtitle2">
            {t("settings.sidebar.title")}
          </Typography>
        </Box>
        <SettingsMenu />
        <BankConnections />
      </Box>
      <SettingsMenuItem
        active={false}
        to="/logout"
        title={t("appSidebar.menu.logout")}
        icon={
          <Box display="flex" alignItems="center" ml={-1}>
            <LogoutIcon />
          </Box>
        }
      />
    </SidebarContainer>
  );
};
